<script>
  import {subNavigation} from "@util//constant"
  import {onMount} from "svelte"
  import {fly,fade} from "svelte/transition"

  import LargeServiceMenu from "./LargeServiceMenu.svelte"
  import LargeBeginnerMenu from "./LargeBeginnerMenu.svelte";
  import LargeRatesMenu from "./LargeRatesMenu.svelte";
  import CampaignMenu from "./CampaignMenu.svelte"
  import LargeSupportMenu from "./LargeSupportMenu.svelte"

  const openAccountLink = "https://minna-no-ginko.go.link/bwUec"
  const serviceIcon = "/assets_default/icons/service.svg"
  const interestrateIcon = "/assets_default/icons/interestrate.svg"
  const campaignIcon = "/assets_default/icons/campaign.svg"
  const beginnerIcon = "/assets_default/icons/beginner.svg"
  const supportIcon = "/assets_default/icons/support.svg"
  const Logo = "/assets_default/icons/logo.svg"

  const LargeNavigatin = [
    {
      icon:serviceIcon,
      label:"サービス",
      Menu:LargeServiceMenu
    },
    {
      icon:interestrateIcon,
      label:"金利・手数料",
      Menu:LargeRatesMenu
    },
    {
      icon:campaignIcon,
      label:"キャンペーン",
      Menu:CampaignMenu
    },
    {
      icon:beginnerIcon,
      label:"初めての方へ",
      Menu:LargeBeginnerMenu
    },
    {
      icon:supportIcon,
      label:"サポート",
      Menu:LargeSupportMenu
    }
  ]

  let hoveredMenuComponent = null;
  let hoveredMenuLabel = "";

  let isHoveringNavTrigger = false;
  let isHoveringMegaMenu = false;

  function handleMouseEnterNav(component, label) {
    hoveredMenuComponent = component;
    hoveredMenuLabel = label;
    isHoveringNavTrigger = true;
  }

  function handleMouseLeaveNav() {
    isHoveringNavTrigger = false;
    setTimeout(() => {
      if (!isHoveringNavTrigger && !isHoveringMegaMenu) {
        hoveredMenuComponent = null;
        hoveredMenuLabel = "";
      }
    }, 100); // 50msの遅延
  }

  function handleMouseEnterMegaMenu() {
    isHoveringMegaMenu = true;
  }

  function handleMouseLeaveMegaMenu() {
    isHoveringMegaMenu = false;
    setTimeout(() => {
      if (!isHoveringNavTrigger && !isHoveringMegaMenu) {
        hoveredMenuComponent = null;
        hoveredMenuLabel = "";
      }
    }, 50); // 50msの遅延
  }

  function closeMegaMenu() {
    hoveredMenuComponent = null;
    hoveredMenuLabel = "";
    isHoveringNavTrigger = false;
    isHoveringMegaMenu = false;
  }


</script>





<header id="header">
  <div class="large-header">
    <div class="header-top-line">
      <div class="header-top-line-left">
        <a href="/">
          <img src={Logo} alt="Minna no Ginko">
        </a>
      </div>
      <div class="header-top-line-right">
        <ul class="header-top-navigation">
          {#each subNavigation.filter(nav => !nav.footer) as nav}
            <li>
              <a href={nav.href}
                target="{nav.blank ? "_blank" : undefined}"
                aria-label="{nav.label}ページへのナビゲーションです"
                id={nav.sendPCID ? nav.sendPCID : undefined}
                class="header-top-navigation-text navigation-link-ga owd-text:03"
                >
                <strong>{nav.label}</strong>
              </a>
            </li>
          {/each}
        </ul>
        <a href={openAccountLink} id="common-pc-header-app" class="header-top-button">口座開設</a>
      </div>
    </div>

    <div class="header-down-line">
      <ul class="header-down-navigation" role="menubar">
        {#each LargeNavigatin as navigation}
          <li
            onmouseenter={() => handleMouseEnterNav(navigation.Menu, navigation.label)}
            onmouseleave={handleMouseLeaveNav}
            role="menuitem"
            aria-haspopup="true"
            aria-expanded={hoveredMenuComponent === navigation.Menu}
          >
            <span class="header-down-navigation-label-icon">
              <span class="header-down-navigation-icon"><img src={navigation.icon} alt="{navigation.label}アイコン"></span>
              <span class="owd-text:02"><strong>{navigation.label}</strong></span>
            </span>
          </li>
        {/each}
      </ul>
    </div>
  </div>

  {#if hoveredMenuComponent}
    <div class="mega-menu-bg" transition:fade></div>
      <div
        class={hoveredMenuLabel == "サービス" ? "mega-menu is-large" : "mega-menu"}
        onmouseenter={handleMouseEnterMegaMenu}
        aria-label="{hoveredMenuLabel}メニュー"
        in:fly={{y:20,delay:50,duration:300}}
        out:fly={{y:-20,delay:50,duration:300}}
      >
      <div class="mega-menu-inner" onmouseleave={handleMouseLeaveMegaMenu}>
      <div class="spacing:bottom:40">
        <svelte:component this={hoveredMenuComponent} />
      </div>
        <div class="align:center">
          <button class="owd-textlink owd-text:02 mega-menu-close" onclick={closeMegaMenu}><strong>閉じる</strong></button>
        </div>
      </div>
    </div>
  {/if}
</header>


<style lang="scss">

  .large-header {
    padding: 16px 24px 24px 24px;
    position: relative;
    z-index: 2;
    // backdrop-filter: blur(10px);
    // overflow: scroll;
  }

  .header-top-line {
    display: grid;
    align-items: center;
    grid-template-columns: 192px 1fr;
    justify-content: space-between;
    @include g.owd-spacing("4");


    &-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .header-top-button {
    width: 120px;
    height: 32px;
    font-size: 12px;
    border: 1px solid var(--primary-black);
    font-weight: 600;
    background: var(--primary-black);
    color: var(--primary-white);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    transition: .2s linear;
    transition-property: background color;
    @include g.owd-typography($fz: 'caption', $line-height-px: 16, $letter-spacing-tracking: 50, $font-weight: 600);

    @media (hover: hover) {
      &:hover {
        background: var(--primary-white);
        color: var(--primary-black);
      }
    }

  }

  .header-top-navigation {
    display: grid;
    grid-template-columns:  repeat(4,auto);
    gap: 24px;
    margin-right: 24px;

    &-text {
      text-decoration: none;
    }

    li {
      position: relative;
      &:after {
        width: 100%;
        height: 2px;
        background: var(--primary-black);
        position: absolute;
        bottom: -6px;
        left: 0;
        content: "";
        display: block;
        opacity: 0;
        transition: .2s linear;
        transition-property: opacity transform;
        transform: translateY(4px);
      }
      @media (hover: hover) {
        &:hover {
          &:after {
            opacity: 1;
            transform: translateY(0);
          }
        }
      }
    }
  }

  .header-down-navigation {
    display: grid;
    grid-template-columns: repeat(5,auto);
    gap: 24px;
    text-align: right;
    justify-content: flex-end;
    align-items: center;
   li {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    &-icon {
      width: 100%;
      display: block;
      line-height: 1;
      img {
        width: 100%;
      }
    }

    &-label-icon {
      display: grid;
      grid-template-columns: 16px 1fr;
      align-items: center;
      gap: 4px;
      height: 100%;
      position: relative;
      &:after {
        width: 100%;
        height: 2px;
        background: var(--primary-black);
        position: absolute;
        bottom: -6px;
        left: 0;
        content: "";
        display: block;
        opacity: 0;
        transition: .2s linear;
        transition-property: opacity transform;
        transform: translateY(4px);
      }
      @media (hover: hover) {
        &:hover {
          &:after {
            opacity: 1;
            transform: translateY(0);
          }
        }
      }
    }
  }

  .mega-menu {
    position: absolute;
    top: 100%;
    left: 50%;
    padding-top: 24px;
    transform: translateX(-50%);
    width: 100%;
    z-index: 5;

    &-inner {
      margin: 0 auto;
      max-width: 1184px;
      background: #fff;
      padding: 48px;
      width: 100%;
    }

    &-bg {
      position: absolute;
      z-index: 3;
      background: rgba(0,0,0,.5);
      top: 106px;
      left: 0;
      width: 100vw;
      height:100vh;
      overflow: hidden;
    }

    &.is-large {
      height: 85vh;
      overflow: scroll;
    }
  }

  .mega-menu-close {
    cursor: pointer;
  }

</style>
